export class QuoteEndorsement {
    id: string = '';
    title: string = '';
    endorsement_text: string = '';
    type: number;       
}
